import logo from "./web-app-manifest-192x192.png";

export default function MyMusicLogo({ size = 40, showText = true }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: size * 0.25 }}>
    <div style={{ width: size, height: size, borderRadius: "50%", overflow: "hidden", flexShrink: 0 }}>
        <img 
          src={logo} 
          alt="MyMusic" 
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "cover",
            transform: "scale(1)"
          }} 
        />
      </div>
      {showText && (
        <span style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: size * 0.55,
          fontWeight: 800,
          color: "#fff",
          letterSpacing: "-0.3px",
          lineHeight: 1,
        }}>
          MyMusic
        </span>
      )}
    </div>
  );
}